/**
 * Collapsed-ribbon group memory: which item of each group the user last
 * ran — the icon shown on the collapsed (daraltılmış) ribbon face (OCS
 * CollapseMode behavior). Session-scope on purpose.
 */

import { create } from 'zustand';

interface PanelMemoryState {
    lastUsed: Record<string, string>;
    record: (groupKey: string, itemKey: string) => void;
}

export const usePanelMemoryStore = create<PanelMemoryState>((set) => ({
    lastUsed: {},
    record: (groupKey, itemKey) => set((s) => ({
        lastUsed: s.lastUsed[groupKey] === itemKey ? s.lastUsed : { ...s.lastUsed, [groupKey]: itemKey },
    })),
}));
